(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-main-product-template"] && !Shopify.designMode) return;
  try {
    class LightningDealCountdown {
    constructor(dealElement, type = 'normal', shouldControlButton = true) {
      this.dealElement = dealElement;
      this.type = type;
      this.shouldControlButton = shouldControlButton;
      this.countdownInterval = null;

      // Get text element based on type
      if (type === 'combo') {
        this.dealTextElement = dealElement.querySelector('.variant__deal-text');
      } else {
        this.dealTextElement = dealElement.querySelector('.lightning-deal__deal-text');
      }

      if (!this.dealTextElement) {
        console.error('Lightning deal text element not found');
        return;
      }

      this.init();
    }

    init() {
      const startTime = this.dealElement.dataset.startTime;
      const endTime = this.dealElement.dataset.endTime;

      if (!startTime || !endTime) {
        // No time data - remove deal-break class and enable button
        if (this.shouldControlButton) {
          removeDealBreakClass();
        }
        return;
      }

      const start = new Date(startTime);
      const end = new Date(endTime);
      const now = new Date();

      const isTimeValid = now >= start && now <= end;

      if (!isTimeValid) {
        if (now < start) {
          this.dealTextElement.textContent = 'Deal Not Started';
          // Deal not started yet - don't disable, just show message
          if (this.shouldControlButton) {
            removeDealBreakClass();
          }
        } else {
          // Deal has ended - add deal-break class
          this.dealTextElement.textContent = 'Deal Ended';
          if (this.shouldControlButton && this.isDealVisible()) {
            addDealBreakClass();
          }
        }
        return;
      }

      // Deal is active - remove deal-break class
      if (this.shouldControlButton && this.isDealVisible()) {
        removeDealBreakClass();
      }

      this.startCountdownTimer(end);
      this.setupTimeExpiryWatcher(end);
    }

    isDealVisible() {
      // For combo products, check if the parent variant is selected
      if (this.type === 'combo') {
        const variantInput = this.dealElement.closest('.variant-input');
        if (variantInput) {
          const radioInput = variantInput.querySelector('input[type="radio"]');
          return radioInput && radioInput.checked;
        }
      }

      return true;
    }

    startCountdownTimer(endTime) {
      const now = new Date();
      let timeLeft = Math.max(0, Math.floor((endTime - now) / 1000));

      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      const updateCountdownDisplay = () => {
        if (timeLeft <= 0) {
          this.dealTextElement.textContent = 'Deal Ended';
          clearInterval(this.countdownInterval);
          // Deal ended - add deal-break class
          if (this.shouldControlButton && this.isDealVisible()) {
            addDealBreakClass();
          }
          return;
        }

        const hours = Math.floor(timeLeft / 3600);
        const minutes = Math.floor((timeLeft % 3600) / 60);
        const seconds = timeLeft % 60;

        this.dealTextElement.textContent = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
        timeLeft -= 1;
      };

      updateCountdownDisplay();
      this.countdownInterval = setInterval(updateCountdownDisplay, 1000);
    }

    setupTimeExpiryWatcher(endTime) {
      const now = new Date();
      const msUntilEnd = endTime - now;

      if (msUntilEnd > 0) {
        setTimeout(() => {
          this.init();
        }, msUntilEnd + 1000);
      }
    }

    pad(num) {
      return num.toString().padStart(2, '0');
    }

    destroy() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    }
  }

  // Add deal-break class when deal has ended
  function addDealBreakClass() {
    const addToCartBtn = document.querySelector('.add-to-cart');
    const stickyAddToCartBtn = document.querySelector('sticky-add-to-cart-button');

    if (addToCartBtn) {
      addToCartBtn.classList.add('deal-break');
      const btnText = addToCartBtn.querySelector('span');
      if (btnText) {
        btnText.textContent = 'Deal Ended';
      }
    }

    if (stickyAddToCartBtn) {
      stickyAddToCartBtn.classList.add('deal-break');
      const stickyBtn = stickyAddToCartBtn.querySelector('button');
      if (stickyBtn) {
        stickyBtn.classList.add('deal-break');
        const stickyBtnText = stickyBtn.querySelector('span');
        if (stickyBtnText) {
          stickyBtnText.textContent = 'Deal Ended';
        }
      }
    }
  }

  // Remove deal-break class when deal is active or variant doesn't have deal
  function removeDealBreakClass() {
    const addToCartBtn = document.querySelector('.add-to-cart');
    const stickyAddToCartBtn = document.querySelector('sticky-add-to-cart-button');

    if (addToCartBtn) {
      addToCartBtn.classList.remove('deal-break');
      addToCartBtn.classList.remove('deal-disabled');

      // Don't override sold out state — only update text if variant is available
      if (!addToCartBtn.disabled) {
        const btnText = addToCartBtn.querySelector('span');
        if (btnText) {
          btnText.innerHTML = btnText.dataset.defaultText || 'Add to Cart';
        }
      }
    }

    if (stickyAddToCartBtn) {
      stickyAddToCartBtn.classList.remove('deal-break');
      stickyAddToCartBtn.classList.remove('deal-disabled');
      const stickyBtn = stickyAddToCartBtn.querySelector('button');
      if (stickyBtn) {
        stickyBtn.classList.remove('deal-break');
        stickyBtn.classList.remove('deal-disabled');
        if (!stickyBtn.disabled) {
          const stickyBtnText = stickyBtn.querySelector('span');
          if (stickyBtnText) {
            stickyBtnText.innerHTML = stickyBtnText.dataset.defaultText || 'Add to Cart';
          }
        }
      }
    }
  }

  function initializeAllLightningDeals() {
    // Initialize normal lightning deal elements
    const normalDealElements = document.querySelectorAll('.lightning-deal__deal[data-start-time][data-end-time]');
    normalDealElements.forEach((dealElement) => {
      if (!dealElement._countdown) {
        // Only control button if this is the visible deal for selected variant
        const isVisible = !dealElement.classList.contains('hidden');
        dealElement._countdown = new LightningDealCountdown(dealElement, 'normal', isVisible);
      }
    });

    // Initialize combo variant deal elements
    const comboDealElements = document.querySelectorAll('.variant__deal[data-start-time][data-end-time]');
    comboDealElements.forEach((dealElement) => {
      if (!dealElement._countdown) {
        // Check if this combo variant is selected
        const variantInput = dealElement.closest('.variant-input');
        const isSelected = variantInput && variantInput.querySelector('input[type="radio"]:checked');
        dealElement._countdown = new LightningDealCountdown(dealElement, 'combo', isSelected);
      }
    });

    // Check if selected variant has a deal and set initial button state
    const selectedRadio = document.querySelector('input[data-variant-input]:checked');
    if (selectedRadio) {
      const isDeal = selectedRadio.dataset.deal === 'true';
      if (!isDeal) {
        // Selected variant doesn't have a deal - ensure button is enabled
        removeDealBreakClass();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', initializeAllLightningDeals);

  // Handle variant change for radio inputs (normal template and combo template)
  document.querySelectorAll('input[data-variant-input]').forEach((ele) => {
    ele.addEventListener('change', (event) => {
      const isDeal = event.target.dataset.deal === 'true';
      const variantInput = event.target.closest('.variant-input');

      if (isDeal) {
        // Find the deal element for this variant (check both normal and combo types)
        let dealElement = variantInput ? variantInput.querySelector('.lightning-deal__deal') : null;
        let dealType = 'normal';

        // If not found, check for combo variant deal element
        if (!dealElement) {
          dealElement = variantInput ? variantInput.querySelector('.variant__deal') : null;
          dealType = 'combo';
        }

        if (dealElement) {
          // Re-initialize countdown for the newly selected variant
          if (dealElement._countdown) {
            dealElement._countdown.destroy();
          }
          dealElement._countdown = new LightningDealCountdown(dealElement, dealType, true);
        }
      } else {
        // Variant doesn't have lightning deal - remove deal-break class
        removeDealBreakClass();
      }
    });
  });

  // Handle variant change for select inputs (sticky bar)
  document.querySelectorAll('select[data-variant-input]').forEach((ele) => {
    ele.addEventListener('change', (event) => {
      const selectedOption = event.target.selectedOptions[0];
      const isDeal = selectedOption && selectedOption.getAttribute('data-deal') === 'true';

      if (isDeal) {
        // Find the corresponding radio input and its deal element (check both normal and combo types)
        const radioInputs = document.querySelectorAll('input[data-variant-input]');
        let matchingDealElement = null;
        let dealType = 'normal';

        radioInputs.forEach((radio) => {
          if (radio.dataset.deal === 'true' && radio.checked) {
            const variantInput = radio.closest('.variant-input');
            // Check for normal deal element first
            let dealElement = variantInput ? variantInput.querySelector('.lightning-deal__deal') : null;
            if (dealElement) {
              matchingDealElement = dealElement;
              dealType = 'normal';
            } else {
              // Check for combo deal element
              dealElement = variantInput ? variantInput.querySelector('.variant__deal') : null;
              if (dealElement) {
                matchingDealElement = dealElement;
                dealType = 'combo';
              }
            }
          }
        });

        if (matchingDealElement) {
          if (matchingDealElement._countdown) {
            matchingDealElement._countdown.destroy();
          }
          matchingDealElement._countdown = new LightningDealCountdown(matchingDealElement, dealType, true);
        }
      } else {
        // Variant doesn't have lightning deal - remove deal-break class
        removeDealBreakClass();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
